import { render, staticRenderFns } from "./shopUser.vue?vue&type=template&id=68a3f829&scoped=true"
import script from "./shopUser.vue?vue&type=script&lang=js"
export * from "./shopUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68a3f829",
  null
  
)

export default component.exports